import { render, staticRenderFns } from "./AFTableColumn.vue?vue&type=template&id=76557746"
import script from "./AFTableColumn.vue?vue&type=script&lang=js"
export * from "./AFTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports